export const TAB = { ALL: '1', DATA_ANALYSIS: '4', OFFICIAL_INSPIRATION: '99' }
export const VIEW_MODE = { IMAGE: 1, TEXT: 2 }

export const EmitterEvents = {
  TIP_KEYS: 'TIP_KEYS'
}

export const TIP_KEYS = ['mn-cooperationTipModal', 'mn-cooperationTipHidden', 'mn-upload-style', 'mn-fenxiang', 'mn-fast-access', 'mn-inspiration-guide']
